module.exports = __webpack_public_path__ + "img/10医学院.37d1e5f4.png";